import { useEffect, useRef, useState } from "react";
import { Configure, Index, useInstantSearch, useSearchBox, UseSearchBoxProps } from "react-instantsearch";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import PanelHits from "../Hits/PanelHits";
import ProductHits from "../Hits/ProductHits";
import { algoliaConfig } from "../../data/config";

export default function Search({ props, fullWidth }: { props?: UseSearchBoxProps; fullWidth?: boolean}) {
    const [searchParams] = useSearchParams();

    const { query, refine } = useSearchBox(props);
    const { status } = useInstantSearch();
    const [inputValue, setInputValue] = useState(query);
    const inputRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();
    const location = useLocation();
    
    const [isClosed, setIsClosed] = useState(false);

    const isSearchStalled = status === 'stalled';

    function setQuery(newQuery: string) {
        setInputValue(newQuery);
    }
    
    useEffect(() => {
        
        if(inputValue.length > 0) {
            setIsClosed(false);
        }

        if(inputValue.length === 0) {
            setIsClosed(true);
        }

    }, [query])

    useEffect(() => {
        if(searchParams.get('initialClose')) setIsClosed(true)
    }, [])

    useEffect(() => {
        const debounce = setTimeout(() => {
            refine(inputValue);
        }, 300);

        return () => clearTimeout(debounce);
    }, [inputValue, refine])

    return (
        <div className={`finish-search-box ${ fullWidth && "finish-search-box--max-width"}`}>
            <form
                className={"finish-search-box__container"}
                action=""
                role="search"
                noValidate
                onSubmit={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    
                    if(location.pathname.includes("products") || location.pathname.includes("produkte") || location.pathname.includes("produits") || location.pathname.includes("productos")) {
                        refine(query)
                    } else {
                        navigate(`/finishes/search?query=${inputValue}&initialClose=true`)
                    }
                    if (inputRef.current) {
                        inputRef.current.blur();
                        setIsClosed(false);
                    }
                    // setQuery("")

                }}
            >
                <div>
                    <button type="submit" className="finish-search-box__submit">
                    </button>
                </div>
                <div className={"finish-search-box__input--wrapper"}>
                    <input
                        className={"finish-search-box__input"}
                        ref={inputRef}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        placeholder={window.steelcase_i18n["steelcase-finish-library"].search_material_product ?? "Search by Material Name or Product"}
                        spellCheck={false}
                        maxLength={512}
                        type="search"
                        value={inputValue}
                        onChange={(event) => {
                            setQuery(event.currentTarget.value);
                        }}
                        
                    />
                </div>
                <span hidden={!isSearchStalled}>Searching…</span>
            </form>

            <div className={"finish-search-box__results"}>
                {
                    <PanelHits isClosed={isClosed} setIsClosed={setIsClosed} query={query} children={<Index indexName={algoliaConfig.PRODUCT_INDEX}><Configure filters="" /><ProductHits clearQuery={() => setQuery("")}/></Index>}/>
                }
            </div>
        </div>
    )
}